"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var consts = require("../constants");
function yobi(date, unit) {
    if (unit === void 0) { unit = '曜日'; }
    return "" + consts.date.yobi[date.getDay()] + unit;
}
exports.default = yobi;
